import { render, staticRenderFns } from "./ProductDesignFormInput.vue?vue&type=template&id=bf0adf5e&"
import script from "./ProductDesignFormInput.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports